export const DESKTOP_MENU_PANEL_ID = "desktopMenuContent";

export const BURGER_MENU_PANEL_ID = "burgerMenuContent";

export const FOCUSABLE_MENU_ITEM_SELECTOR = "a[href], button:not([disabled])";
